import { Component, OnInit } from '@angular/core';
import { Sidebar2SubpanelStateService } from '../../sidebar2-subpanel-state.service';

@Component({
    selector: 'app-sidebar2-rfq-sub-menu',
    templateUrl: './sidebar2-rfq-sub-menu.component.html',
    standalone: false,
})
export class Sidebar2RfqSubMenuComponent implements OnInit {
    // @ts-ignore TS7008
    quoteRequestStatuses;
    constructor(private subpanelService: Sidebar2SubpanelStateService) {}

    ngOnInit() {
        this.getRFQStatuses();
    }

    getRFQStatuses() {
        this.subpanelService.getQuoteRequestsPromise().then((res) => {
            this.quoteRequestStatuses = res;
        });
    }
}
